import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

declare var Stripe;
declare var paymentRequest;
@Injectable()
export class StripServiceService {
  stripe: any;
  constructor(private _http: HttpClient) { }

  initStripe(venueSetting: any): any {
    this.stripe = Stripe(venueSetting.stripe_test_mode ? environment.stripeTestApiKey : environment.stripeApiKey,
      { stripeAccount:  venueSetting.stripe_connected_account_id });
    if (venueSetting.stripe_test_mode) {
      this.stripe = Stripe(environment.stripeTestApiKey);
    }

    return this.stripe;
  }

  generatePaymentRequest(venueSetting: any, total: number): any {
    return this.stripe.paymentRequest( {
      country: venueSetting.country_code ? venueSetting.country_code : 'AU',
      currency: venueSetting.currency ? venueSetting.currency.toLowerCase() : 'aud',
      total: {
        label: venueSetting.name ? venueSetting.name : 'Payment',
        amount: total
      },
      requestPayerName: false,
      requestPayerEmail: false,
    });
  }
  createPaymentIntent(paymentData: any, stripeTest: boolean): Promise<any> {
    let url = environment.api + 'voucher/placeOrder/paymentIntent';
    if (stripeTest) {
      url = environment.api + 'voucher/placeOrder/paymentIntentDemo';
    }
    return this._http.post(url, paymentData).toPromise();
  }

  confirmPaymentIntent (id: string, paymentIntent: any, hash: any, stripeTest: boolean): Promise<any> {
    let url = environment.api + 'voucher/placeOrder/finalize/' + id;
    if (stripeTest) {
      url = environment.api + 'voucher/placeOrder/finalizeDemo/' + id;
    }
    return this._http.post(url, {
      payment_intent_id: paymentIntent.id,
      hash: hash
    }).toPromise();
  }

  buyVoucher(v_id: string, stripe_token: string, formData: any, voucher: any): Observable<any> {
    const data: any[] = [];
    data.push(voucher);
    const url = environment.api + 'voucher/placeOrder?hash=' + v_id;
    // let params = new HttpParams()
    // .set('stripe_token', stripe_token)
    // .set('data', JSON.stringify(data))
    // .set('buyer_full_name', formData.buyer_full_name)
    // .set('buyer_email', formData.buyer_email)
    // .set('recipient_full_name', formData.recipient_full_name)
    // .set('recipient_email', formData.recipient_email)
    // .set('comment', formData.comment);

    return this._http.post(url, {
      stripe_token: stripe_token,
      data: JSON.stringify(data),
      buyer_full_name: formData.buyer_full_name,
      buyer_email: formData.buyer_email,
      recipient_full_name: formData.recipient_full_name,
      recipient_email: formData.recipient_email,
      comment: formData.comment
    });
  }

  validateOrder(v_id: string, voucher: any): Observable<any> {
    const data: any[] = [];
    data.push(voucher);
    const url = environment.api + 'voucher/checkOrder?hash=' + v_id;

    return this._http.post(url, { data: JSON.stringify(data) });
  }

}
